import classNames from "classnames";
import { domAnimation, LazyMotion, m } from "framer-motion";
import React from "react";
import style from "../../scss/export.module.scss";
import { LogoIcon, SpinnerIcon } from "../Icons";
import { Overlay } from "../Overlay";
import "./loading-indicator.scss";

type Props = {
    show: boolean;
    splashScreen?: boolean;
};

export const LoadingIndicator = ({ show, splashScreen = false }: Props) => {
    //TODO Spinner component?
    const renderSpinner = () => {
        return (
            <LazyMotion features={domAnimation}>
                <m.div
                    animate={{ rotate: [0, 360] }}
                    transition={{
                        duration: 0.8,
                        ease: "easeInOut",
                        repeat: Infinity,
                    }}
                >
                    <SpinnerIcon size={50} color={style.brandBlueColor} className="u-d-block" />
                </m.div>
            </LazyMotion>
        );
    };

    return (
        <>
            <Overlay show={show && !splashScreen} />
            {show && (
                <div className={classNames("c-loading-indicator", { "c-loading-indicator--splash": splashScreen })}>
                    {splashScreen ? <LogoIcon color={style.greyColor} size={100} /> : renderSpinner()}
                </div>
            )}
        </>
    );
};
